export const parseJsonBody = async (response) => {
    let textBody;
    try {
        textBody = await response.text();
    }
    catch (e) {
        // Check text
    }
    if (!textBody) {
        return null;
    }
    try {
        return JSON.parse(textBody);
    }
    catch (_) {
        return textBody;
    }
};
